<template>
  <div>
    IndexValuation
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>